import { __decorate } from "tslib";
import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
let MessagesComponent = class MessagesComponent {
    messages = [];
    closable = false;
    escape = true;
    severity = 'warning';
    notifyChange;
    pMessagesVC;
    ngOnInit() {
        if (this.notifyChange) {
            this.notifyChange.subscribe(() => {
                if (this.pMessagesVC?.cd) {
                    this.pMessagesVC.cd.markForCheck();
                }
            });
        }
    }
    static propDecorators = {
        messages: [{ type: Input }],
        closable: [{ type: Input }],
        escape: [{ type: Input }],
        severity: [{ type: Input }],
        notifyChange: [{ type: Input }],
        pMessagesVC: [{ type: ViewChild, args: ['pMessages',] }]
    };
};
MessagesComponent = __decorate([
    Component({
        selector: 'messages',
        encapsulation: ViewEncapsulation.None,
        template: `
    <p-messages
      #pMessages
      [(value)]="messages" [severity]="severity"
      [escape]="escape" [enableService]="false" [closable]="closable">
    </p-messages>
  `,
        styles: ["\n    .p-message {\n      margin: 0;\n      @media only screen and (max-width : 1200px) {\n        font-size: 0.9em;\n      }\n    }\n    .p-message-wrapper {\n      justify-content: center;\n    }\n  "]
    })
], MessagesComponent);
export { MessagesComponent };
